module.exports = __webpack_public_path__ + "img/sappoQR.8e77e6f7.png";